export default `using System;
using System.Security.Cryptography;
using System.Text;

public class CannyHashGenerator
{
    private static readonly string APIKey = "YOUR_API_KEY";

    public static string GenerateCannyHash(string userId)
    {
        using (var hmac = new HMACSHA256(Encoding.UTF8.GetBytes(APIKey)))
        {
            var hash = hmac.ComputeHash(Encoding.UTF8.GetBytes(userId));
            return BitConverter.ToString(hash).Replace("-", "").ToLower();
        }
    }
}

}`;
